export default "__VITE_ASSET__B2B75k2k__"